export enum GeoModelJobStatus {
  Completed = "Completed",
  PartiallyCompleted = "Partially Completed",
  NotStarted = "Not started",
  Error = "Error",
  Queued = "Queued",
  Cancelling = "Cancelling",
  Cancelled = "Cancelled"
}

export type InvalidReason =
  | "MissingHeader"
  | "MissingSurvey"
  | "MissingGeology"
  | "MissingOnProdDate"
  | "Missing3dvOutput"
  | "MissingXdaOutput"
  // EVA-150: keep in the same order as the two .NET enums (eva-metrics-calc and EVA.ThreeDvSvc
  // Models/InvalidItem.cs). The reason is persisted by NAME, so this union has to list every
  // member the workers can write or the first consumer that maps or compares one will miss it.
  | "NoThreeDGeoSubscription"
  | "NoGeologySubscription"
  | "MissingResourcePlay"
  // EVA-189: the metrics-calc spacing pass produced no value while another stage did.
  | "MissingSpacingOutput"
  // EVA-255: the xda job ran but returned no areas, typically no offsetting wells in range.
  | "EmptyXdaResult"
  | "Unknown";

export interface InvalidItem {
  id: string;
  entityType: "Well" | "Stick";
  reason: InvalidReason;
  detail?: string;
}
